 <template>
  <div class="searchItemList search">
    <div class="nav">
      <header>
        <form action="/">
          <van-search
            v-model="searchValue"
            placeholder="搜索“可丽金”"
            show-action
            clearable
            maxlength="32"
            @search="search"
            @cancel="cancel"
          />
        </form>
      </header>
      <ul>
        <li :class="{'navColor': navIndex==index}" v-for="(item, index) of nav" @click="navClick(index)">{{item}}</li>
      </ul>
    </div>
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="list" v-if="navIndex == 0">
        <div class="listItem" ref="listItem1">
            <community-item v-for="(item, index) in list1" :prolistItem="item" :key="index"></community-item>
        </div>
        <div class="listItem" ref="listItem2">
          <community-item v-for="(item, index) in list2" :prolistItem="item" :key="index"></community-item>
        </div>
      </div>
       <div class="list list-comp" v-else>
         <topic-list-comp v-for="(item, index) of topiclist" :topicItem="item" :key="index"></topic-list-comp>
       </div>
    </Scroller>
    <div v-if="((list.length <= 0 && navIndex == 0) || (topiclist.length <= 0 && navIndex == 1)) && empty" class="emptybox" :style="{'height': emptyHeight/100 + 'rem'}">
      <empty v-if="empty" :path="'noIntegral'" :noDatades="2"></empty>
    </div>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
import { customRequestAjax } from '@/axiosApi'
import communityItem from '../common/communityItem'
import empty from '../emptypage/empty'
import topicListComp from '../common/topicListComp'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'communitySearchResult',
  components: {
    Scroller,
    communityItem,
    topicListComp,
    empty
  },
  data: function () {
    return {
      nav: ['帖子', '话题'],
      navIndex: 0,
      index: 1,
      topiclist: [],
      list: [],
      list1: [],
      list2: [],
      hasevaluate: null,
      follow: true,
      nowPage: 0,
      refresh: false,
      loading: false,
      finished: false,
      noDataText: '—— 客官，木有啦~ ——',
      searchValue: '',
      historyList: [],
      empty: false,
      emptyHeight: 0
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$nextTick(() => {
      setTimeout(() => {
        this.emptyHeight = document.body.clientHeight - document.getElementsByClassName('nav')[0].clientHeight
        console.log(this.emptyHeight, document.body.clientHeight, document.getElementsByClassName('nav')[0], document.getElementsByClassName('nav')[0].clientHeight)
      }, 0)
    })
    if (this.$route.query.searchval) {
      this.searchValue = decodeURIComponent(this.$route.query.searchval)
    }
    if (this.searchValue !== '') {
      this.noRepeat()
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/' && from.name != 'homePage') { // 当前页面刷新不需要切换位置
      next(vm => {
        if (isWeixin()) fenxiang({path: 'communitysearchresult'})
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.empty = false
        vm.nowPage = 0
        vm.list1 = []
        vm.list2 = []
        vm.topiclist = []
      })
    } else {
      next(vm => {
        if (from.path != '/communitydetail' && from.path != '/communityfollow'){
          Object.assign(vm.$data, vm.$options.data());
        }
        if (vm.$route.query.searchval) {
          vm.searchValue = decodeURIComponent(vm.$route.query.searchval)
        }
        if (vm.searchValue !== '') {
          vm.noRepeat()
        }
        if (isWeixin()) fenxiang({path: 'communitysearchresult'})
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path != '/communitydetail' && to.path != '/communityfollow') this.loading = true
    next()
  },
  methods: {
    getData: function () {
      var that = this
      var url = 'Wxmall/Community/searchTopic'
      url = url + '?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&keywords=' + this.searchValue + '&type=' + that.navIndex
      customRequestAjax(url)
        .then(function (res) {
          if (res.data.code == 200) {
            if (that.nowPage == 1) {
              if (that.navIndex == 0) {
                that.list = res.data.itemlist
                that.list1 = []
                that.list2 = []
              } else {
                that.topiclist = res.data.itemlist
              }
              that.refresh = false
            } else if (that.navIndex != 0) {
              that.topiclist = that.topiclist.concat(res.data.itemlist)
            }
            that.loading = false
            if (res.data.itemlist.length < that.pagesize) {
              that.finished = true
              if (that.nowPage == 1 && res.data.itemlist.length == 0) {
                that.empty = true
                console.log(that.empty)
              }
            } else {
              that.finished = false
            }
            if (that.navIndex == 0) {
              that.$nextTick(() => {
                setTimeout(() => {
                  that.doSort(0, res.data.itemlist)
                }, 100)
              })
            }
          }
        })
    },
    doSort (index, list) {
      let that = this
      if (index < list.length) {
        f()
        function f() {
          if (that.$refs.listItem1.clientHeight <= that.$refs.listItem2.clientHeight) {
            that.list1.push(list[index])
          } else {
            that.list2.push(list[index])
          }
          if (index < list.length - 1) {
            that.loading = true
          } else {
            that.loading = false
          }
          that.$nextTick(() => {
            setTimeout(() => {
              that.doSort(index + 1, list)
            }, 100)
          })
        }
      }
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    },
    noRepeat: function () {
      if (localStorage.getItem('community-historylist') !== null && localStorage.getItem('community-historylist') !== undefined && localStorage.getItem('community-historylist') !== '') {
        this.historyList = JSON.parse(localStorage.getItem('community-historylist'))
        var historyArr = []
        var obj = {}
        this.historyList.unshift(this.searchValue)
        for (var i of this.historyList) {
          if (!obj[i]) {
            historyArr.push(i)
            obj[i] = 1
          }
        }
        if (historyArr.length > 20) {
          historyArr.splice(historyArr.length - 1, 1)
          localStorage.setItem('community-historylist', JSON.stringify(historyArr))
        } else {
          localStorage.setItem('community-historylist', JSON.stringify(historyArr))
        }
      } else {
        this.historyList.unshift(this.searchValue)
        localStorage.setItem('community-historylist', JSON.stringify(this.historyList))
      }
    },
    search: function () {
      this.empty = false
      if (this.searchValue != '') {
        this.noRepeat()
        this.nowPage = 0
        this.list1 = []
        this.list2 = []
        this.onInfinite()
      } else {
        if (this.defaultSearch) {
          this.searchValue = this.defaultSearch
          this.noRepeat()
          this.nowPage = 0
          this.list1 = []
          this.list2 = []
          this.onInfinite()
        } else {
          this.$toast('请正确输入查询内容')
        }
      }
      if (this.searchValue != '') {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/searchword/save',
          data: {
            type: 'community',
            keyword: this.searchValue
          }
        })
      }
    },
    cancel: function () {
      this.$router.go(-1)
    },
    navClick: function (id) {
      this.empty = false
      if (this.navIndex != id) {
        this.navIndex = id
        this.nowPage = 0
        this.list1 = []
        this.list2 = []
        this.onInfinite()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .nav {
    position: relative;
    z-index: 1;
    header {
      padding-left: 0.1rem;
      background: #ffffff;
    }
    ul {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 0.44rem;
      margin-top: 0.01rem;
      background: #ffffff;
      li {
        color: #292929;
        font-size: 0.15rem;
        width: 50%;
        text-align: center;
        &.navColor {
          font-weight:600;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            display: block;
            width: 0.26rem;
            height: 0.03rem;
            background: linear-gradient(90deg,#FC0324 0%,#FC0324 100%);
          }
        }
      }
    }
  }
  .list {
    width: 100%;
    padding-right: 0.1rem;
    overflow: hidden;
    margin-top: 0.1rem;
    &.list-comp {
      padding-left: 0.1rem;
    }
    .listItem {
      padding-left: 0.1rem; // 剧中
      width: 50%;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/community/communitySearchResult.vue